import { getLocationService } from '@guiker/base-entity'

export const getCountryFromCitySlug = (citySlug: string) => {
  return getLocationService().getCityBySlug(citySlug)?.country
}
